import { SiteConfig } from '~/config'
import type { RichTextContent } from '~/types/content'

const { CUSTOM, BLOCKS, yourbowAdPositionDesktop, yourbowAdPositionMobile } =
	SiteConfig.richText

/** Injects an Insticator node at the appropriate location */
export function withInlineYourbowAds(
	rootNode: RichTextContent,
	isDesktop: boolean
): RichTextContent {
	if (rootNode.nodeType !== 'document' || !rootNode.content) return rootNode

	// Remove existing Yourbow Inline Ads.
	// Avoids duplicate divs being created on rerenders, but allows changing injection points when switching between Mobile/Desktop
	rootNode.content = rootNode.content.filter(
		(node) => node.nodeType != CUSTOM.YOURBOW
	)

	const yourbowPosition = isDesktop
		? yourbowAdPositionDesktop
		: yourbowAdPositionMobile

	// Don't start the injection until after the insticator node
	const startIndex =
		rootNode.content?.findIndex((node) => node.nodeType == CUSTOM.INSTICATOR) ||
		0

	let paragraphCount = 0
	let inlineAdCount = 0
	rootNode.content?.forEach((contentNode, index) => {
		if (index <= startIndex) return
		if (contentNode.nodeType == BLOCKS.PARAGRAPH) paragraphCount++

		if (paragraphCount == yourbowPosition) {
			// Insert a yourbow inline ad AFTER the current node
			rootNode.content?.splice(index + 1, 0, {
				nodeType: CUSTOM.YOURBOW,
				data: {
					yourbowInlineAdNumber: ++inlineAdCount
				},
				marks: []
			})
			paragraphCount = 0 // reset paragraph count after insert
		}
	})

	return rootNode
}
